import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect, RouteProps, useHistory } from 'react-router-dom';
import { RootState } from '../../redux/store';

interface Props extends RouteProps {
    component: any;
}

const PrivateRoute: React.FC<Props> = ({ component: Component, ...rest }) => {
    const { authenticated } = useSelector((state: RootState) => state.auth);
    const history = useHistory();
    return(
        <Route {...rest} render={props => authenticated ? <div className="centerWithNav"><Component {...props} /></div> : <Redirect to="/login" />} />
      );
}

export default PrivateRoute;